export default "__VITE_ASSET__DmZGJBqC__"